module.exports = __webpack_public_path__ + "img/5-Stepp-Populated-Details-Page.751f93ca.png";